document.addEventListener('focusin', function(event) {
  const target = event.target;

  if (!(target instanceof Element)) return;

  const textInputSelector = 'input, select, textarea, button, [tabindex]:not([tabindex="-1"])';
  
  if (!target.matches(textInputSelector)) return;

  const popupContainer = target.closest('.tee-edit-popup');
  if (popupContainer) {
    setTimeout(() => {
      const rect = target.getBoundingClientRect();
      
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
     
      const isVisibleAndSafe = (rect.top >= 20) && (rect.bottom <= (viewportHeight - 30));

      if (isVisibleAndSafe) {
        return; 
      }

      const distanceToTop = -10;
      const scrollContainer = target.closest('.tee-dialog-body') || target.closest('.vm--modal');

      if (scrollContainer && scrollContainer.scrollHeight > scrollContainer.clientHeight) {
        const absoluteTop = rect.top + window.scrollY;
        window.scrollTo({
          top: absoluteTop - distanceToTop - window.visualViewport.offsetTop,
          behavior: 'smooth'
        });
      } 
      else if (window.visualViewport) {
        const absoluteTop = rect.top + window.scrollY;
        window.scrollTo({
          top: absoluteTop - distanceToTop - window.visualViewport.offsetTop,
          behavior: 'smooth'
        });
      } 
      else {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

    }, 400);
  }
});